const BASE_ROUTE = "/onboarding";

export const ONBOARDING_ROUTE = {
  BASE: BASE_ROUTE,
  MAIN_INFO: `${BASE_ROUTE}/main-info`,
  CHOOSE_PLAN: `${BASE_ROUTE}/choose-plan`,
  BMI: `${BASE_ROUTE}/warm-up/bmi`,
  ELIGIBILITY_QUESTIONS: `${BASE_ROUTE}/warm-up/health`,
  ELIGIBILITY_QUESTIONS_DQ: `${BASE_ROUTE}/warm-up/dq-health`,
  CHOOSE_TREATMENT: `${BASE_ROUTE}/choose-treatment`,
  SUMMARY: `${BASE_ROUTE}/checkout`,
  CHECKOUT: `${BASE_ROUTE}/checkout/payment`,
  ACCOUNT_PERSONAL_DETAILS: `${BASE_ROUTE}/account-personal-details`,
  ACCOUNT_CONTACT_DETAILS: `${BASE_ROUTE}/account-contact-details`,
  ACCOUNT_PASSWORD: `${BASE_ROUTE}/account-password`,
} as const;
